import { render, staticRenderFns } from "./WithFooterAndHeader.vue?vue&type=template&id=38e2f5d2&"
import script from "./WithFooterAndHeader.vue?vue&type=script&lang=js&"
export * from "./WithFooterAndHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports